import { type Card, cardToString } from './cards.js';

/** Exact preimage format; the browser verifier must reproduce this string byte-for-byte. */
export function openingPreimage(handId: string, position: number, card: Card, saltHex: string): string {
  return `${handId}|${position}|${cardToString(card)}|${saltHex}`;
}
